import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useForm from "../../../hooks/useForm";
import * as AuthActions from "../../../store/auth/actions";
import "./style.scss";
import { textIdentifier } from "../../../textIdentifier";

export default function ResetPassword() {
  const routes = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { resetPasswordSuccess, resetPasswordFailure, errorMessage } =
    useSelector((state) => state.auth);
    const {lang} = useSelector(state => state.main)

  const [isLoading, setIsLoading] = useState(true);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [isError, setIsError] = useState("");

  const handleSubmit = async (values) => {
    setIsError("");
    const vals = { ...values };
    delete vals.confirm_password;
    dispatch(AuthActions.resetPasswordCta(values));
  };

  const Form = useForm({
    initialValues: {
      username: "",
      code: "",
      password: "",
      confirm_password: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.password.trim()) {
        errors.password = textIdentifier['invalid-password-please-enter-a-valid-password'][lang];
      }
      if (values.password.trim() && values.password.length < 6) {
        errors.password = textIdentifier['password-should-be-minimum-6-character-long'][lang];
      }
      if (!values.confirm_password.trim()) {
        errors.confirm_password = textIdentifier['invalid-please-re-enter-password'][lang];
      }
      if (
        values.confirm_password &&
        values.password !== values.confirm_password
      ) {
        errors.confirm_password = textIdentifier["invalid-password-did't-match"][lang];
      }
      return errors;
    },
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    const search = routes.search;
    const urlParams = new URLSearchParams(search);
    const code = urlParams.get("code");
    const username = urlParams.get("username");
    if (code && username) {
      setIsLoading(false);
      Form.setFieldValue("username", username);
      Form.setFieldValue("code", code);
    } else {
      navigate("/signin");
    }
  }, []);

  useEffect(() => {
    if (resetPasswordSuccess) {
      dispatch(AuthActions.resetPasswordCtaInit());
      setIsError("");
      setIsSuccessful(true);
    }

    if (resetPasswordFailure) {
      setTimeout(() => {
        setIsError(errorMessage);
        dispatch(AuthActions.resetPasswordCtaInit());
        Form.resetForm({ confirm_password: "" });
        Form.setSubmitting();
      }, 500);
    }
  }, [resetPasswordFailure, resetPasswordSuccess]);

  if (isLoading) return <div>{textIdentifier["loading"][lang]}...</div>;
  return (
    <main className="reset-password">
      <div className="card text-center shadow-sm">
        {/* logo */}
        <div className="logo-container">
          <Link to="/">
            <img src="/static/images/svg/logo.svg" alt="logo" />
          </Link>
        </div>

        <h1>{textIdentifier["enter-password"][lang]}</h1>

        {/* login form */}
        <form onSubmit={Form.handleSubmit}>
          <div className="form-group">
            <label htmlFor="password" className="form-label">
              {textIdentifier["enter-new-password"][lang]}
            </label>
            <input
              type="password"
              className="form-control"
              placeholder={textIdentifier["min-6-characters"][lang]}
              id="password"
              value={Form.values.password}
              onChange={Form.handleChange}
              disabled={Form.isSubmitting}
            />
            <div id="helperText" className="form-text">
              {Form.errors.password}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirm_password" className="form-label">
            {textIdentifier["re-enter-new-password"][lang]}
            </label>
            <input
              type="password"
              className="form-control"
              placeholder={textIdentifier["min-6-characters"][lang]}
              id="confirm_password"
              value={Form.values.confirm_password}
              onChange={Form.handleChange}
              disabled={Form.isSubmitting}
            />
            {Form.errors.confirm_password && (
              <div id="helperText">{Form.errors.confirm_password}</div>
            )}
            {isError && <div id="helperText">{isError}</div>}
          </div>

          {!isSuccessful && Form.isSubmitting ? (
            <Spinner
              variant="primary"
              animation="border"
              style={{ alignSelf: "center" }}
            />
          ) : (
            <div className="form-group text-center">
              {isSuccessful ? (
                <div id="helperText">{textIdentifier["password-reset-successfully"][lang]}</div>
              ) : (
                <button type="submit">{textIdentifier["reset-password"][lang]}</button>
              )}
              <Link to={"login"}>{textIdentifier["go-back-to-login"][lang]}</Link>
            </div>
          )}
        </form>
      </div>
    </main>
  );
}
